import { Component, OnInit, ViewChild, TemplateRef, Output, EventEmitter } from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { CuentasPorCobrarService } from '../../../services/cuentas-por-cobrar.service';
import { ConstantsService } from '../../../services/constants.service';
import { CatalogosSatService } from '../../../services/catalogos-sat-service';

@Component({
  selector: 'app-modal-facturar-recepcion-pago',
  templateUrl: './modal-facturar-recepcion-pago.component.html',
  styleUrls: ['./modal-facturar-recepcion-pago.component.scss']
})
export class ModalFacturarRecepcionPago implements OnInit {
    @ViewChild('content') private content: TemplateRef<any>;
    @Output() public onRecepcionPagoFacturado: EventEmitter<any> = new EventEmitter;

    //Modelos
    public cxc:any;
    public emails_facturacion: string = '';
    public arregloPagos: any[] = [];
    public formasPago: any[] = [];

    //Helpers
    public modal: any = null;
    public factura_generada: boolean = false;
    public errors: any = {};
    public loading: boolean = false;
    public loadingFormasPago:boolean=false;

    constructor(public cuentas_por_cobrar_service:CuentasPorCobrarService, 
        private constant: ConstantsService, 
        private modalService: NgbModal,
        private satService: CatalogosSatService) { 

    }
    
    ngOnInit() {
      
    }

    public openModal(cxc){
        this.inicializarComponente();
        this.factura_generada=false;
        this.cxc = cxc;
        this.emails_facturacion = cxc.tipo_cuenta === 'VENTA' ? cxc.cliente_email : cxc.miembro_email;

        this.modal = this.modalService.open(this.content, { size: 'lg' });
    }

    private inicializarComponente(){
      let arregloPagos = [];

      let nuevoPago = {error: {}};
      arregloPagos.push(nuevoPago);
      this.arregloPagos = arregloPagos;
      this.cargarFormasPago(nuevoPago);
    }

    public closeModal() {
        this.modal.close();
    }

    public agregarDocumentoPago() {
      let nuevoPago = {error: {}};
      this.arregloPagos.push(nuevoPago);
      this.seleccionaFormaPagoDefault(nuevoPago);
    }

    public generarFactura(){
      this.loading = true;
  
      let recepcionPagos = {
        email_facturacion: this.emails_facturacion,
        id_cuenta_por_cobrar: this.cxc.id_cuenta_por_cobrar,
        pagos: this.arregloPagos
      };
  
      this.errors = this.cuentas_por_cobrar_service.validarRecepcionPagos(recepcionPagos);
  
      if (Object.entries(this.errors).length > 0) {
        this.loading = false;
        return false;
      }
  
      this.cuentas_por_cobrar_service.facturarRecepcionPagos(recepcionPagos)
      .subscribe(
        (response)=>{
          this.factura_generada=true;
          this.loading = false;
          this.closeModal();
          this.onRecepcionPagoFacturado.emit(this.cxc);
        },
        (error)=>{
          this.loading = false;
          alert("ERROR:: "+JSON.stringify(error));
        }
      );
    }

    private cargarFormasPago(pago){
      this.loadingFormasPago = true;
  
      this.satService.obtenerFormasPago()
      .subscribe(
        (response)=>{
          let formasPago = response.json().content;
          this.formasPago = formasPago;
          this.seleccionaFormaPagoDefault(pago);
  
          this.loadingFormasPago = false;
        },
        (error)=>{
          this.loadingFormasPago = false;
          alert("ERROR:: "+JSON.stringify(error));
        }
      );
    }

    private seleccionaFormaPagoDefault(pago){
      //Seleccionar la forma de pago default
      let component = this;
      this.formasPago.forEach(function(formaPago) {
        if(formaPago.codigo === CuentasPorCobrarService.FORMA_PAGO_DEFAULT){
          component.seleccionarFormaPago(formaPago, pago);
        }
      });
    }

    private seleccionarFormaPago(formaPago, pago){
      //Seleccionar la forma de pago default
      pago.formaPagoSeleccionado = formaPago;
      pago.forma_pago = formaPago.codigo;
    }

    private eliminarPago(index){
      this.arregloPagos.splice(index, 1);
    }    
}


// WEBPACK FOOTER //
// ./src/app/components/reporte-cxc/modal-facturar-recepcion-pago/modal-facturar-recepcion-pago.component.ts